<template>
  <div style="width:100%">
    <Login v-if="!$auth.isAuthenticated"></Login>
    <list-reminders v-else :showExcluded="false"></list-reminders>
  </div>
</template>

<script>
import ListReminders from "@/components/reminders/ListReminders";
import Login from "@/views/Login";
export default {
  components: {
    ListReminders,
    Login
  },
  mounted() {
    this.$router.push("reminders");
  }
};
</script>
